const fmt = (n) =>
  n >= 1e6 ? (n / 1e6).toFixed(1) + 'M' : n >= 1e3 ? (n / 1e3).toFixed(1) + 'K' : n.toLocaleString();

const CARDS = [
  { key: 'totalClaims',       label: 'Total Claims',      icon: '📋', accent: '#0066cc' },
  { key: 'completed',         label: 'Completed',         icon: '✅', accent: '#10b981' },
  { key: 'failed',            label: 'Failed',            icon: '❌', accent: '#ef4444' },
  { key: 'successRate',       label: 'Success Rate',      icon: '📈', accent: '#3b82f6', unit: '%' },
  { key: 'totalUploaded',     label: 'Uploaded Images',   icon: '📷', accent: '#4fb4cf' },
  { key: 'relevantImages',    label: 'Relevant Images',   icon: '🖼️', accent: '#6366f1' },
  { key: 'partsIdentified',   label: 'Parts Identified',  icon: '🔍', accent: '#f59e0b' },
];

export default function KpiCards({ kpis }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3">
      {CARDS.map(({ key, label, icon, accent, unit }) => {
        const val = kpis[key];
        const pct =
          key === 'completed' ? ((val / kpis.totalClaims) * 100).toFixed(1) :
          key === 'failed'    ? ((val / kpis.totalClaims) * 100).toFixed(1) : null;

        return (
          <div key={key} className="bg-background-secondary rounded-lg border border-border-primary shadow-sm p-4 flex flex-col gap-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center text-base"
              style={{ background: accent + '18' }}>
              {icon}
            </div>
            <div>
              <p className="text-2xl font-bold text-text-primary leading-none">
                {unit === '%' ? val + '%' : fmt(val)}
              </p>
              {pct && (
                <p className="text-xs font-medium mt-0.5" style={{ color: accent }}>
                  {pct}% of total
                </p>
              )}
            </div>
            <p className="text-xs text-text-secondary font-medium">{label}</p>
          </div>
        );
      })}
    </div>
  );
}
